const LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/hh.brian99?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr',
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        aria-hidden="true"
      >
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    label: 'Snapchat',
    href: 'https://snapchat.com/t/0xc4Ump3',
    icon: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
        <path d="M12 2.3c3.3 0 5.7 2.4 5.8 5.6 0 .7-.1 1.7-.1 2.4 0 .2.1.3.3.4.4.2.9.4 1.4.5.4.1.6.5.4.8-.2.4-.7.5-1.2.7-.4.1-.6.3-.5.7.4 1.5 2 2.7 3.8 3.1.4.1.5.5.3.8-.4.5-1.2.7-1.9.8-.1 0-.2.1-.2.3-.1.4-.2.8-.7.9-.5.1-1.4-.1-2.2 0-.7.1-1.1.5-1.7 1-.9.7-1.7 1.4-3.4 1.4s-2.5-.7-3.4-1.4c-.6-.5-1-.9-1.7-1-.8-.1-1.7.1-2.2 0-.5-.1-.6-.5-.7-.9 0-.2-.1-.3-.2-.3-.7-.1-1.5-.3-1.9-.8-.2-.3-.1-.7.3-.8 1.8-.4 3.4-1.6 3.8-3.1.1-.4-.1-.6-.5-.7-.5-.2-1-.3-1.2-.7-.2-.3 0-.7.4-.8.5-.1 1-.3 1.4-.5.2-.1.3-.2.3-.4 0-.7-.1-1.7-.1-2.4.1-3.2 2.5-5.6 5.8-5.6z" />
      </svg>
    ),
  },
];

export function SocialLinks({ className = '' }) {
  return (
    <div className={`social-links ${className}`.trim()}>
      {LINKS.map((l) => (
        <a
          key={l.label}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={l.label}
          title={l.label}
          className="social-links__link"
        >
          {l.icon}
        </a>
      ))}
    </div>
  );
}
